export default __webpack_public_path__ + "static/media/discounts-go-big-image.c6c375ae.svg";